import PropType from 'prop-types'

import CheckCircleIcon from '@hapana/shared/web/styles/assets/svgs/check-circle-small.svg'
import ErrorCircleIcon from '@hapana/shared/web/styles/assets/svgs/close-icon.svg'
import InfoIcon from '@hapana/shared/web/styles/assets/svgs/info-small.svg'
import CrossIcon from '@hapana/shared/web/styles/assets/svgs/cross.svg'

export const TOAST_PROPS_OPTIONS = {
  SEVERITY: {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',
  },
  HORIZONTAL: {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
  },
}

export const TOAST_PROP_TYPES = {
  severity: PropType.oneOf(Object.values(TOAST_PROPS_OPTIONS.SEVERITY)).isRequired,
  title: PropType.string.isRequired,
  description: PropType.string,
  isOpen: PropType.bool.isRequired,
}

export const TOAST_AUTO_HIDE_DURATION = 5 * 1000

export const TOAST_CLOSE_REASONS = {
  CLICKAWAY: 'clickaway',
}

export const TOAST_ICON_MAP = {
  success: CheckCircleIcon,
  error: ErrorCircleIcon,
  info: InfoIcon,
}

export const TOAST_CLOSE_ICON = CrossIcon

export const resolveSeverity = (severity) => {
  if (severity === 'warning') {
    return 'info'
  }
  if (['success', 'error', 'info'].includes(severity)) {
    return severity
  }
  return 'info'
}
